"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePenOptions = void 0;
const useToolsOptionsSelector_1 = require("./useToolsOptionsSelector");
const penOptionsBase_1 = require("../mocks/penOptionsBase");
const DEFAULT_PEN_OPTIONS = new penOptionsBase_1.PenOptionsBase();
const usePenOptions = () => (0, useToolsOptionsSelector_1.useToolsOptionsSelector)(state => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.penOptions) !== null && _a !== void 0 ? _a : DEFAULT_PEN_OPTIONS; });
exports.usePenOptions = usePenOptions;
